import type { TreatmentLocation } from 'application/types';

export default function formatLocation(location: TreatmentLocation): string {
  return `${location.street} ${location.streetNumber}, ${location.postalCode} ${location.locality}`;
}
